import { Popup, Button, Tooltip } from 'devextreme-react';
import { createPortal } from 'react-dom';
import { useRef } from 'react';
import { BoardViewer } from '../board-viewer/BoardViewer';
import './BoardPopup.scss';
import { board } from '../../../images/icons';

interface BoardPopupProps {
  visible: boolean;
  board: any;
  onHide: () => void;
  isMinimized?: boolean;
  onMinimize?: () => void;
  onMaximize?: () => void;
}

export const BoardPopup = ({ visible, board: boardData, onHide, isMinimized = false, onMinimize, onMaximize }: BoardPopupProps) => {
  const boardName = boardData?.Rp_Nombre || 'Tablero de Control';
  const isMinimizingRef = useRef(false);

  // Si no está visible, no renderizar nada
  if (!visible) {
    return null;
  }

  const handleMinimize = () => {
    isMinimizingRef.current = true;
    onMinimize?.();
  };

  const handlePopupHiding = () => {
    // Solo cerrar si no estamos minimizando
    if (!isMinimizingRef.current) {
      onHide();
    }
    isMinimizingRef.current = false;
  };

  // Widget minimizado - usar portal para renderizar fuera del header
  const minimizedWidget = isMinimized && boardData ? createPortal(
    <div className='board-minimized-widget' id='board-minimized-widget'>
      <div className='board-minimized-icon'>
        <img src={board} alt='Tablero' />
      </div>
      <div className='board-minimized-name' onClick={onMaximize}>
        {boardName}
      </div>
      <div className='board-minimized-actions'>
        <Button icon='fullscreen' stylingMode='text' onClick={onMaximize} hint='Maximizar' />
        <Button icon='close' stylingMode='text' onClick={onHide} hint='Cerrar' />
      </div>
      <Tooltip target='#board-minimized-widget' showEvent='mouseenter' hideEvent='mouseleave' position='top'>
        Click para maximizar: {boardName}
      </Tooltip>
    </div>,
    document.body
  ) : null;

  return (
    <>
      {/* Widget minimizado flotante */}
      {minimizedWidget}

      {/* Popup normal */}
      <Popup
        visible={!isMinimized}
        onHiding={handlePopupHiding}
        dragEnabled={true}
        closeOnOutsideClick={false}
        showCloseButton={false}
        showTitle={true}
        title={boardName}
        width={'90vw'}
        height={'90vh'}
        className='board-popup'
        toolbarItems={[
          {
            widget: 'dxButton',
            location: 'after',
            options: {
              icon: 'minus',
              stylingMode: 'text',
              hint: 'Minimizar',
              onClick: handleMinimize,
            },
          },
          {
            widget: 'dxButton',
            location: 'after',
            options: {
              icon: 'close',
              stylingMode: 'text',
              hint: 'Cerrar',
              onClick: onHide,
            },
          },
        ]}
      >
        <BoardViewer board={boardData} height='calc(90vh - 100px)' showCloseButton={false} onMinimize={handleMinimize} />
      </Popup>
    </>
  );
};
